import React from 'react';
import { MapPin, Mail, Phone, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = ({ setCurrentPage }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white py-12 border-t-4 border-blue-700 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10 mb-8">
          {/* Company Info */}
          <div>
            <div className="text-2xl font-display font-bold mb-4">
              <span className="text-blue-300">AIXpert</span>
            </div>
            <p className="text-blue-200 text-sm mb-6 leading-relaxed">
              Platform belajar Data Science & AI dengan metode pembelajaran up-to-date & mentor berpengalaman.
            </p>

            <div className="space-y-3">
              <div className="flex items-start gap-3 text-sm text-blue-200">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-blue-100 mb-1">Alamat:</p>
                  <p>
                    Jl. Pulo Buaran Raya. III, Blok FF-5 KIP<br />
                    Kel. Jatinegara, Kec. Cakung<br />
                    Jakarta Timur 13930, Indonesia
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-blue-100">Menu Cepat</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <button
                  onClick={() => {
                    setCurrentPage('program');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-blue-200 hover:text-white transition flex items-center gap-2 group"
                >
                  <span className="text-blue-400 group-hover:text-blue-300">→</span>
                  Program Kelas
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setCurrentPage('silabus');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-blue-200 hover:text-white transition flex items-center gap-2 group"
                >
                  <span className="text-blue-400 group-hover:text-blue-300">→</span>
                  Silabus
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setCurrentPage('careers');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-blue-200 hover:text-white transition flex items-center gap-2 group"
                >
                  <span className="text-blue-400 group-hover:text-blue-300">→</span>
                  Karir
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setCurrentPage('about');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-blue-200 hover:text-white transition flex items-center gap-2 group"
                >
                  <span className="text-blue-400 group-hover:text-blue-300">→</span>
                  Tentang Kami
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    setCurrentPage('home');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-blue-200 hover:text-white transition flex items-center gap-2 group"
                >
                  <span className="text-blue-400 group-hover:text-blue-300">→</span>
                  Beranda
                </button>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-blue-100">Hubungi Kami</h3>
            <div className="space-y-3 mb-6">
              <a href="mailto:info@dataandai.academy" className="flex items-center gap-3 text-sm text-blue-200 hover:text-white transition">
                <div className="bg-blue-700 p-2 rounded-lg">
                  <Mail className="w-4 h-4 text-blue-300" />
                </div>
                info@dataandai.academy
              </a>
              <a href="tel:+628123456789" className="flex items-center gap-3 text-sm text-blue-200 hover:text-white transition">
                <div className="bg-blue-700 p-2 rounded-lg">
                  <Phone className="w-4 h-4 text-blue-300" />
                </div>
                +62 897-8554-012
              </a>
            </div>

            <div>
              <p className="font-semibold mb-3 text-blue-100">Ikuti Kami:</p>
              <div className="flex gap-3">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-blue-700 hover:bg-blue-600 p-3 rounded-xl transition">
                  <Instagram className="w-5 h-5 text-blue-200" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="bg-blue-700 hover:bg-blue-600 p-3 rounded-xl transition">
                  <Linkedin className="w-5 h-5 text-blue-200" />
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="bg-blue-700 hover:bg-blue-600 p-3 rounded-xl transition">
                  <Youtube className="w-5 h-5 text-blue-200" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-700 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-blue-300">
            <p>© {currentYear} AIXpert by VeloCT & ISTN. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#privacy" className="hover:text-white transition">Privacy Policy</a>
              <a href="#terms" className="hover:text-white transition">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
